import { UseFormReturn, useWatch } from "react-hook-form";
import { SelectFormData } from "../../types/form";
import { FancySelect } from "./form.comp";
import { useTranslation } from "../../core/translation.core";

export function BatchToggleButton({ methods }: { methods: UseFormReturn<SelectFormData, any> }) {
  const { t, msg } = useTranslation();
  const selectedIds = useWatch({ name: "selectIds", control: methods.control });
  const enableSelect = selectedIds && selectedIds.length > 0;

  if (!enableSelect) return null;

  return (
    <button
      type="button"
      className="bg-her-dodgerblue hover:font-semibold text-white px-2 rounded-md h-9 my-2"
      onClick={() => methods.setValue("selectIds", [])}
    >
      {enableSelect ? t(msg.form.cancel) : t(msg.general.select)}
    </button>
  );
}

export function BatchAction({
  methods,
  onSubmit,
}: {
  methods: UseFormReturn<SelectFormData>;
  onSubmit: (data: SelectFormData) => void;
}) {
  const { t, msg } = useTranslation();
  const selectedIds = useWatch({ name: "selectIds", control: methods.control });
  const enableSelect = selectedIds && selectedIds.length > 0;

  if (!enableSelect) return null;

  return (
    <form className="flex gap-2 itmes-center" onSubmit={methods.handleSubmit(onSubmit)}>
      <FancySelect
        register={methods.register}
        fieldName="option"
        options={[
          { label: t(msg.form.bulkActions), value: "" },
          { label: t(msg.form.delete), value: "delete" },
        ]}
      />
      <BatchActionBtn methods={methods} />
    </form>
  );
}

export function BatchActionBtn({ methods }: { methods: UseFormReturn<SelectFormData> }) {
  const [option, selectIds] = useWatch({
    name: ["option", "selectIds"],
    control: methods.control,
  });

  function isDisabled() {
    if (!selectIds) return true;
    if (selectIds.length === 0) return true;
    if (option === "") return true;
    return false;
  }

  return <input type="submit" className="h-9 my-2" disabled={isDisabled()} />;
}
